import React from "react";
import Image from "next/image";
import { Box, Flex, Text } from "rebass/styled-components";
import Heading from "../common/Heading";
import Icon from "../common/Icon";
import { GetDogProfileQuery } from "../../generated/graphql";

interface Props {
  dog: GetDogProfileQuery["dog"];
}

const Avatar = ({ dog }: Props) => {
  return (
    <Flex
      px={[2, 2, 0]}
      sx={{
        mt: 3
      }}
    >
      <Box
        width="152px"
        height="152px"
        sx={{
          ".image": {
            borderRadius: "50% !important"
          }
        }}
      >
        <Image
          src={dog.avatar?.circle}
          width="152px"
          height="152px"
          className="image"
          priority
          alt={`${dog.name} avatar`}
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />
      </Box>

      <Box ml={3}>
        <Box>
          <Heading
            as="h1"
            sx={{
              fontSize: "32px"
            }}
            itemProp="name"
            mb={"4px"}
          >
            {dog.name}

            {dog.breed && (
              <Text
                sx={{
                  fontSize: "14px",
                  fontWeight: "body"
                }}
                mt={1}
              >
                {dog.breed?.tName}
              </Text>
            )}
          </Heading>
        </Box>
        <Box
          sx={{
            fontSize: "14px",
            lineHeight: "18px",
            letterSpacing: "0.5px"
          }}
        >
          <Text>{dog.tAge}</Text>
          <Text>{dog.tGender}</Text>
          <Text>{dog.tSize}</Text>
        </Box>
        {!!dog.user?.city && (
          <Flex
            sx={{
              alignItems: "center"
            }}
          >
            <Icon name="marker" color="aquamarine" />
            <Text sx={{ marginLeft: "0.25em" }}>{dog.user?.city?.name}</Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default Avatar;
